import React from 'react'
import { View, Alert, Platform } from 'react-native'
import tw from 'tailwind-rn'
import { useNavigation } from '@react-navigation/native'

import styles from './styles'
import { HGButton, HGText, HGGroup } from '../HGUI'
import { BlockChildrenOverviewType } from '../../config/types'
import Disclaimer from './Disclaimer'
import Cooperation from './Cooperation'

type Props = {
  data: BlockChildrenOverviewType
}

const BlockChildrenOverview = (props: Props) => {
  const navigation = useNavigation()
  const { data } = props
  const { copy } = data

  const c = copy.reduce((prev, curr) => {
    prev[curr.key] = curr.value
    return prev
  }, {})

  const _handleDocument = () => {
    if (Platform.OS !== 'web') {
      Alert.alert(c.alertTitle || '', c.alertBody, [
        // { text: 'Mehr Informationen' },
        { text: c.alertActionCancel, style: 'cancel' },
        {
          text: c.alertActionDocumentNow,
          onPress: () => navigation.navigate('Documentation'),
        },
      ])
    } else {
      navigation.navigate('Documentation')
    }
  }

  return (
    <View style={tw('pb-6')}>
      <HGGroup style={{ paddingTop: 0 }}>
        <HGText style={styles.questionText}>{c.question}</HGText>
      </HGGroup>

      <HGGroup transparentMode>
        <View style={styles.actionBox}>
          <HGButton
            style={tw('w-full my-3')}
            // size={'large'}
            title={c.answerActionDocument}
            onPress={() => _handleDocument()}
          />

          <HGButton
            style={tw('w-full my-3')}
            // size={'large'}
            type="inverted"
            title={c.answerActionMoreInfo}
            onPress={() => navigation.navigate('Info')}
          />
        </View>
      </HGGroup>

      <Cooperation />

      <Disclaimer text={c.disclaimerText} />
    </View>
  )
}

export default BlockChildrenOverview
